import React, { useState } from "react";
import CustomButton from "../../common/CustomButton";

const TeamInfoSidebar = ({ teamInfo, setTeamName, teamName, handleUpdate , loading}) => {
  const [isEditing, setIsEditing] = useState(false);

  const { name, members, bod, md, teamId } = teamInfo;




  return (
    <div className="">
      {/* Team Name Section */}
      <div className="bg-gradient-to-r f rounded-lg p-4 border border-blue-100">
        <div className="flex items-center justify-between mb-3">
          <label className="text-sm font-semibold text-gray-700 flex items-center gap-2">
            Team Name
          </label>
        </div>
        <div className="space-y-3">
          <input
            type="text"
            maxLength={50}
            value={teamName || ""}
            onChange={(e) => setTeamName(e.target.value)}
            className="w-full px-3 py-2 rounded-[10px] input-focus"
            placeholder="Enter team name"
            autoFocus
          />
        </div>
      </div>

      {/* Members Section */}
      <div className=" mt-3 rounded-lg p-4 border border-green-100">
        <div className="flex items-center gap-2 mb-3">
          <span className="text-lg"></span>
          <h3 className="font-semibold text-gray-700">Members</h3>
          <span className="ml-auto bg-green-100 text-green-800 px-2 py-1 rounded-full text-xs font-medium">
            {members?.length || 0}
          </span>
        </div>

        <div className="bg-white rounded-md p-3 max-h-32 overflow-y-auto">
          {members?.length > 0 ? (
            <ul className="space-y-2">
              {members.map((member, index) => (
                <li
                  key={index}
                  className="flex items-center gap-2 text-gray-700"
                >
                  <span className="w-2 h-2 bg-green-400 rounded-full"></span>
                  {member?.name || "Unnamed Member"}
                </li>
              ))}
            </ul>
          ) : (
            <div className="text-gray-500 text-center py-2 italic">
              No members added yet
            </div>
          )}
        </div>
      </div>

      {/* BOD Section */}
      {bod?.length > 0 && (
        <div className=" mt-3 rounded-lg p-4 border border-purple-100">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-lg"></span>
            <h3 className="font-semibold text-gray-700">Board of Directors</h3>
            <span className="ml-auto bg-purple-100 text-purple-800 px-2 py-1 rounded-full text-xs font-medium">
              {bod.length}
            </span>
          </div>

          <div className="bg-white rounded-md p-3 max-h-32 overflow-y-auto">
            <ul className="space-y-2">
              {bod.map((bodMember, index) => (
                <li
                  key={index}
                  className="flex items-center gap-2 text-gray-700"
                >
                  <span className="w-2 h-2 bg-purple-400 rounded-full"></span>
                  {bodMember?.name || "Unnamed BOD Member"}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {/* MD Section */}
      <div className=" mt-3 rounded-lg p-4 border border-orange-100">
        <div className="flex items-center gap-2 mb-3">
          <span className="text-lg"></span>
          <h3 className="font-semibold text-gray-700">Managing Directors</h3>
          <span className="ml-auto bg-orange-100 text-orange-800 px-2 py-1 rounded-full text-xs font-medium">
            {md?.name ? 1 : 0}
          </span>
        </div>

        <div className="bg-white rounded-md p-3 max-h-32 overflow-y-auto">
          {md?.name ? (
            <>
              {md.name && (
                <div className="flex items-center gap-2 text-gray-700">
                  <span className="w-2 h-2 bg-orange-400 rounded-full"></span>
                  {md?.name || "Unnamed Member"}
                </div>
              )}
            </>
          ) : (
            <div className="text-gray-500 text-center py-2 italic">
              No managing directors assigned
            </div>
          )}
        </div>
      </div>

      {/* Update Button */}
      <div className="pt-4 border-t text-center flex justify-center border-gray-100">
        <CustomButton
          label="Update Team"
          isDisabled={loading}
          onClick={() => handleUpdate(teamId, teamName)}
          className="w-full flex items-center justify-center"
        />
      </div>
    </div>
  );
};

export default TeamInfoSidebar;
